/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import { ColumnCommonProps } from '@g17eco/types/survey-question-list';
import { Button } from 'reactstrap';
import { isMaterialityQuestionReadOnly } from '../utils';
import { Column } from '@g17eco/molecules/tracking-list';

const getLabel = (isShowing: boolean, isReadOnly: boolean) => {
  if (isReadOnly) {
    return 'Locked';
  }

  return isShowing ? 'Hide' : 'Show';
};

export const getColumnAnswerIndicator =
  (questionId?: string) => (props: Pick<ColumnCommonProps, 'question' | 'handleGoToQuestion'>) => {
    const { question, handleGoToQuestion } = props;
    const isShowing = questionId === question.utrv?._id;
    const iconClassName = isShowing ? 'fa-caret-up' : 'fa-caret-down';
    const isReadOnly = isMaterialityQuestionReadOnly({ code: question.universalTracker.getCode() });

    return (
      <Column className='text-center'>
        <Button disabled={isReadOnly} color='link' size='xs' onClick={handleGoToQuestion}>
          {getLabel(isShowing, isReadOnly)}
          <i className={`fal ${iconClassName} ms-2`} />
        </Button>
      </Column>
    );
  };
